import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	overflow: hidden;
	flex: 0 0 auto;
	white-space: nowrap;
	width: 100%;
	border-bottom: 1px solid var(--border-color);
	@media ${Breakpoints.mobile} {
		padding: 0 var(--padding-2);
	}
`;

export const ItemContainer = styled.div`
	position: relative;
	${({ isFillContainer }) =>
		isFillContainer &&
		css`
			display: flex;
		`}

	> button {
		display: flex;
	}
`;

export const ButtonCss = (props) => css`
	display: inline-block;
	margin-right: unset !important;

	&.borderless {
		background: transparent !important;
		> .typography {
			font-size: var(--paragraph2-font-size) !important;
			color: var(--black) !important;
			font-weight: ${props.selected ? '500' : '400'};
		}

		> .typography {
			color: var(--black) !important;
		}
	}

	body[dir='rtl'] & {
		margin-right: unset;
	}

	@media ${Breakpoints.mobile} {
		background: ${props.selected ? 'var(--black)' : 'var(--background-3)'} !important;

		&.borderless {
			> .typography {
				color: var(--black) !important;
			}

			:hover,
			:focus,
			:active {
				> .typography {
					color: var(--black) !important;
				}
			}
		}
	}
`;

export const Slider = styled.div`
	background-color: var(--blue);
	transition: 0.3s;
	height: 0.3rem;
	width: ${(props) => `${props.width}px`};
	transform: ${(props) => `translateX(${props.sliderLeft}px)`};

	body[dir='rtl'] & {
		transform: ${(props) => `translateX(-${props.sliderLeft}px)`};
	}
	@media ${Breakpoints.mobile} {
		/* display: none !important; */
	}
`;
